













































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwTable, TableColumnConfig, TableEntry, ColumnSortRequestData, SortedColumnInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { CreateElement, VNode } from 'vue';
// import { envCongif } from '@/shared/env.config';
const cssPrefix = 'downloadCenterChildTable';

@Component({
  components: {
    ...UUIFComponents,
    SwTable,
    SwIconButton,
    SwIcon,
  },
})

export default class DownloadCenterChildTable extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop() downloadCenterData: any;

  sortedColumns: SortedColumnInfo[] = [];

  get contentTableConfig(): TableColumnConfig[] {
    return [
      {
        key: 'name',
        dataKey: 'name',
        title: (this.$t('downloadcenter.name')
        .toString()),
        sorter: true,
        /* tslint:disable-next-line */
        render: (h, data): VNode => {
          return (
            data.entry.showAEPC ?
            <a><span on-click={() => { this.$emit('getApecInfo'); }}> {data.entry.name} </span></a> :
            <span>{data.entry.name}</span>
          ) as VNode;
        },
      },
      {
        key: 'version',
        dataKey: 'version',
        sorter: true,
        title: (this.$t('downloadcenter.version')
        .toString()),
      },
      {
        key: 'releaseDate',
        dataKey: 'releaseDate',
        title: this.$t('downloadcenter.releaseDate')
        .toString(),
        sorter: ((a: any, b: any) => {
          const aReleaseDate: any = new Date(a.releaseDate);
          const bReleaseDate: any = new Date(b.releaseDate);
          return aReleaseDate - bReleaseDate;
        }),
      },
      {
        key: 'firmwareEndDate',
        dataKey: 'firmwareEndDate',
        /* tslint:disable-next-line */
        title: (h: CreateElement): VNode => {
          return (
            <div style="display:flex;align-items:center;">
              <span style="margin-right:1rem;"> { this.$t('downloadcenter.eosDate')
              .toString() } </span>
              <div style="cursor:pointer;">
                <SwIcon name="informational" props-size={15} color="#47afe2" v-tooltip={{ content: this.$t('common.eosInfo'), compact: true, placement: 'bottom' }} ></SwIcon>
              </div>
            </div>
          ) as VNode;
        },
        sorter: true,
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              >
                <span style={ data.entry.firmwareStatus === 'ACTIVE' ? '' : 'color: red' }> {data.entry.firmwareEndDate} </span>
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'fileSize',
        dataKey: 'fileSize',
        title: (this.$t('downloadcenter.fileSize')
        .toString()),
        sorter: true,
      },
      {
        key: 'instruciton',
        dataKey: 'instruction',
        title:  (this.$t('downloadcenter.instruction')
        .toString()),
        sorter: true,
      },
      {
        key: 'action',
        dataKey: 'action',
        /* tslint:disable-next-line */
        render: (h, data): VNode => {
          return (
          <span>
          {
            <SwIcon
              style={{ visibility: data.entry.md5HashValue ? 'visible' : 'hidden' }}
              props-name = {'info'}
              v-tooltip={{
                content: `${(this.$t('downloadcenter.checkSum')
                .toString())}: ${data.entry.md5HashValue}`,
                compact  : true,
                placement: 'top',
                maxWidth:275,
              } as TooltipDirValues}>
            </SwIcon>
          }
          {
            <a href = { data.entry.releaseNoteURL } target = "_blank" style={{ visibility: data.entry.releaseNoteURL ? 'visible' : 'hidden' }}>
              <SwIconButton
                props-name={'file-text2'}
                props-icon={'file-text2'}
                v-tooltip={{ content: (this.$t('downloadcenter.releaseNote')
                .toString()), compact: true, placement: 'top', maxWidth:150 }}>
              </SwIconButton>
            </a>
          }
          {
            <SwIconButton
              // tslint:disable-next-line
              style={ [{ visibility: data.entry.downloadCount ? 'visible' : 'hidden' }, { cursor: data.entry.firmwareStatus === 'ACTIVE' ? 'pointer' : 'not-allowed' }] }
              props-name = {'download'}
              props-icon={'download'}
              v-tooltip={{
                content:`${(this.$t('downloadcenter.fileSize')
                .toString())}: ${data.entry.fileSize}`,
                compact: true,
                placement: 'top',
                // maxWidth:150,
              } as TooltipDirValues}
              nativeOn-click={() => {
                data.entry.firmwareStatus === 'ACTIVE' && this.downloadSoftware(data.entry);
              }}>
            </SwIconButton>
          }
          {
            <SwIconButton
              style={{ visibility: data.entry.downloadCount ? 'visible' : 'hidden' }}
              props-name={'stats-growth'}
              props-icon={'stats-growth'}
              v-tooltip={{
                content:`${(this.$t('downloadcenter.download')
                .toString())}: ${data.entry.downloadCount}`,
                compact: true,
                placement: 'top',
              // maxWidth:150,
              } as TooltipDirValues}>
            </SwIconButton>
          }
          </span>
          ) as VNode;
        },
      },
    ];
  }

  get tableData() {
    return this.downloadCenterData?.softwareList?.map((ele: any, index: any) => {
      return {
        _key: index,
        firmwareStatus: this.downloadCenterData?.firmwareStatus,
        firmwareEndDate: this.downloadCenterData?.firmwareEndDate,
        name: ele.name,
        version: ele.version,
        intVersion: ele.intVersion,
        releaseDate: ele.releaseDate,
        fileSize: ele.fileSize,
        instruction: ele.instruction,
        md5HashValue: ele.md5HashValue,
        downloadCount: ele.downloadCount,
        releaseNoteURL: ele.releaseNoteURL,
        aepcText: ele.aepcText,
        showAEPC: ele.showAEPC,
        softwareID: ele.softwareID,
        softwareGroupID: ele.softwareGroupID,
        isRNotes: ele.isRNotes,
      };
    });
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  downloadSoftware(data: any) {

    // const sessionId = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const userId = this.$store.getters.getUserId;
    const payload = { username:userId, swID:data.softwareID, swGrpID: data.softwareGroupID, isRNotes: data.isRNotes, appName:'MSW', oemCode:'SNWL' };
    this.$store.dispatch(
      'DownloadCenterStoreModule/downloadSoftware', payload,
    )
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      } else {
        window.open(resp.content.downloadUrl);
      }
    })
    .catch((errorRes: any) => {
      console.error(errorRes.message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

}
